"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAppleCampaignNameSchema = exports.AppleCampaignNameSchema = exports.SyncAppleChannelBodySchema = exports.ImportAppleCampaignBodySchema = exports.CreateAppleRegionCommonFields = exports.UpdateAppleRegionCommonFields = exports.CreateAppleChannelFields = exports.UpdateAppleChannelFields = exports.AppleChannelIdFields = exports.AppleChannelTargetingDimensionsSchema = exports.AppleInvoiceDetailsSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
// This matches the Apple invoicing, but we control it.
exports.AppleInvoiceDetailsSchema = typebox_1.Type.Object({
    billingEmail: core_1.EmailSchema,
    buyerEmail: core_1.EmailSchema,
    buyerName: core_1.NameSchema,
    clientName: typebox_1.Type.Optional(core_1.NameSchema),
    orderNumber: typebox_1.Type.Optional(core_1.NameSchema),
}, {
    title: "LOC Invoice Details",
    description: "The response to a request to fetch campaign details for a standard invoicing payment model.",
});
exports.AppleChannelTargetingDimensionsSchema = (0, core_1.StrictObject)({
    adminArea: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        included: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    })),
    age: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        included: typebox_1.Type.Array((0, core_1.StrictObject)({
            maxAge: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 18, maximum: 65 })),
            minAge: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 18, maximum: 65 })),
        })),
    })),
    appDownloaders: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        // Should be a AppleProxyAdamRef but Apple wants a string!
        included: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
        excluded: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    })),
    appCategories: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        included: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Number())),
        excluded: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Number())),
    })),
    country: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        included: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.CountrySchema)),
    })),
    daypart: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        userTime: (0, core_1.StrictObject)({
            included: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.Integer({
                minimum: 0,
                maximum: 167,
            }))),
        }),
    })),
    deviceClass: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        included: typebox_1.Type.Optional(typebox_1.Type.Array(apple_proxy_web_1.AppleProxyDeviceClassSchema)),
    })),
    gender: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        included: typebox_1.Type.Optional(typebox_1.Type.Array(apple_proxy_web_1.AppleProxyGenderSchema)),
    })),
    locality: (0, core_1.OptionalNullable)((0, core_1.StrictObject)({
        included: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
    })),
});
exports.AppleChannelIdFields = {
    id: core_1.IdSchema,
    campaignId: core_1.IdSchema,
};
exports.UpdateAppleChannelFields = {
    storefront: (0, core_1.OptionalNullable)(core_1.CountrySchema),
    targetingDimensions: (0, core_1.OptionalNullable)(exports.AppleChannelTargetingDimensionsSchema),
    defaultBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    status: typebox_1.Type.Optional(ruby_1.AppleChannelStatusSchema),
    keywordBidStrategy: typebox_1.Type.Optional(ruby_1.KeywordBidStrategySchema),
    productPageRef: (0, core_1.OptionalNullable)(apple_proxy_web_1.AppleProxyCustomProductPageRefSchema),
    // Only one of invoiceDetails and budget orders can be set.
    budgetOrders: (0, core_1.OptionalNullable)(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    // This is not required (or desired on hosted or Apple PAYG pricing)
    invoiceDetails: (0, core_1.OptionalNullable)(exports.AppleInvoiceDetailsSchema),
    cpdGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    useLifetimeBudget: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
};
exports.CreateAppleChannelFields = {
    storefront: typebox_1.Type.Optional(core_1.CountrySchema),
    applicationRef: ruby_1.AppleProxyRefSchema,
    orgRef: typebox_1.Type.Optional(ruby_1.AppleProxyOrgRefSchema),
    targetingDimensions: (0, core_1.OptionalNullable)(exports.AppleChannelTargetingDimensionsSchema),
    defaultBidAmount: core_1.MoneySchema,
    status: ruby_1.AppleChannelStatusSchema,
    productPageRef: (0, core_1.OptionalNullable)(apple_proxy_web_1.AppleProxyCustomProductPageRefSchema),
    // Only one of invoiceDetails and budget orders can be set.
    budgetOrders: (0, core_1.OptionalNullable)(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    // This is not required (or desired on hosted or Apple PAYG pricing)
    invoiceDetails: (0, core_1.OptionalNullable)(exports.AppleInvoiceDetailsSchema),
    cpdGoal: core_1.MoneySchema,
    useLifetimeBudget: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
};
exports.UpdateAppleRegionCommonFields = {
    cpdGoal: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    budgetWeighting: typebox_1.Type.Optional(core_1.WeightingSchema),
    defaultBidAmount: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    status: typebox_1.Type.Optional(ruby_1.AppleChannelRegionStatusSchema),
};
exports.CreateAppleRegionCommonFields = {
    country: core_1.CountrySchema,
    budgetWeighting: core_1.WeightingSchema,
    defaultBidAmount: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    status: ruby_1.AppleChannelRegionStatusSchema,
    cpdGoal: (0, core_1.OptionalNullable)(core_1.MoneySchema),
};
exports.ImportAppleCampaignBodySchema = (0, core_1.StrictObject)({
    regionId: core_1.IdSchema,
    orgRef: ruby_1.AppleProxyOrgRefSchema,
    campaignRef: ruby_1.AppleProxyRefSchema,
    adGroups: typebox_1.Type.Array((0, core_1.StrictObject)({
        adGroupRef: ruby_1.AppleProxyRefSchema,
    })),
    sync: ruby_1.SyncModeSchema,
});
exports.SyncAppleChannelBodySchema = (0, core_1.StrictObject)({
    campaignRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    mode: typebox_1.Type.Optional(ruby_1.SyncModeSchema),
});
exports.AppleCampaignNameSchema = (0, core_1.StrictObject)({
    campaignRef: ruby_1.AppleProxyRefSchema,
    name: typebox_1.Type.String(),
    regions: typebox_1.Type.Array((0, core_1.StrictObject)({
        country: core_1.CountrySchema,
        purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
    })),
});
exports.UpdateAppleCampaignNameSchema = (0, core_1.StrictObject)({
    campaignRef: ruby_1.AppleProxyRefSchema,
    name: typebox_1.Type.String(),
});
